import { styled } from '@mui/material';

export const BirthdayImage = styled('img')`
  height: 227px;
  width: 100%;
  display: block;
  margin-bottom: 16px;
  object-fit: contain;

  @media (max-width: 1023px) {
    height: 218px;
  }
`;

export const BirthdayDescription = styled('div')`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;
